import { createFileRoute } from '@tanstack/react-router';
import { OrderListScreen } from '@/features/orderlist/OrderListScreen';

export const Route = createFileRoute('/_app/order-list')({
  component: OrderListScreen,
});
